export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_2.4538953f.jpg";